import { z } from 'zod';

export const McpConfigSchema = z.object({
  baseURL: z
    .url()
    .refine(v => !v.endsWith('/mcp'), {
      message: 'VITE_MCP_BASE_URL must not include the /mcp path; consumers append it',
    })
    .transform(v => v.replace(/\/+$/, '')),
});

export type McpConfig = z.infer<typeof McpConfigSchema>;
